import { showHouseApi } from "../../../../../apis/showHouseApi";
import { TrackingSys } from "../../../../../constants/TrackingSys";

export const searchShowHouses = (
  dataSearchHouse,
  setHouse,
  setFields,
  setMessageError,
  setHousePresent,
) => {
  if (validateDataSearchHouse(dataSearchHouse)) {
    showHouseApi
      .getShowHousePending(dataSearchHouse)
      .then((data) => {
        setHouse({
          houseNum: data.houseNum,
          year: data.year,
          cdRefGiant: data.cdRefGiant,
        });
        data.fields = data.fields.sort(
          (field, nextField) => field.priority - nextField.priority
        );
        setFields({ ...data, houseNum: data.houseNum });
        setHousePresent(true);
      })
      .catch((error) => {
        if (error.response && error.response.status === 400) {
          setMessageError(error.response.data.messages[0]);
          setHousePresent(false);
        } else {
          setHousePresent(null);
          setMessageError(error.message);
          console.error("Ocorreu um erro ao buscar house de exibição.", error);
        }
      });
  } else {
    setHousePresent(null);
  }
};

const validateDataSearchHouse = ({ trackingSysId, houseNum, houseYear }) => {
  if (!trackingSysId || !houseNum || !houseYear) 
    return false;

  if (isNaN(trackingSysId) || isNaN(houseYear)) 
    return false;

  if (trackingSysId !== TrackingSys.IMPORT_MILESTONES && trackingSysId !== TrackingSys.EXPORT_MILESTONES)
    return false;

  if (houseYear.toString().length !== 4) 
    return false;

  return true;
};
